module.exports = __webpack_public_path__ + "static/media/480.73328951.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-strawberry/light/480.png
// module id = 2498
// module chunks = 2